export default __webpack_public_path__ + "static/Perfect5-af31c62a425713201c551c241af5ef1c.jpg";